import { Analytics } from "@vercel/analytics/react"

declare global {
  interface Node {
    _patchedRemoveChild?: boolean;
  }
}

if (typeof Node !== "undefined" && Node.prototype && !Node.prototype._patchedRemoveChild) {
  const original = Node.prototype.removeChild;

  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    try {
      if (child && child.parentNode === this) {
        // 👇 coerção de tipo explícita — o retorno é o mesmo tipo de entrada
        return original.call(this, child) as T;
      }
    } catch (e) {
      console.warn("Patched removeChild error:", e);
    }

    return child;
  };

  Node.prototype._patchedRemoveChild = true;
}


import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
// import { datadogRum } from '@datadog/browser-rum';

// datadogRum.init({
//   applicationId: 'c3f788b14c2bbd624fcd31f937789eecd215efeb',
//   clientToken: 'pubd71019bf442270b63d9e5e200e34e051',
//   site: 'datadoghq.com', // or 'datadoghq.eu', 'us3.datadoghq.com', etc.
//   service: 'sortelect-frontend',
//   env: 'production', // or 'production', 'staging', etc.
//   version: '1.0.0', // Your application version
//   sessionSampleRate: 100, // Percentage of sessions to track
//   sessionReplaySampleRate: 20, // Percentage of sessions to record for replay
//   trackUserInteractions: true,
//   trackResources: true,
//   trackLongTasks: true,
//   defaultPrivacyLevel: 'mask-user-input',
// });
// Import the generated route tree

import { routeTree } from './routeTree.gen'
import "./styles/global.scss"

import reportWebVitals from './reportWebVitals.ts'
import { NotificationContextProvider } from "./contexts/notification-context-provider.tsx";
import { Maintenance } from "./components/maintenance";
import { MAINTENANCE_MODE } from "./common/constants";

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.getElementById('app')
rootElement?.setAttribute("notranslate", "true")
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      {MAINTENANCE_MODE ? (
        <Maintenance />
      ) : (
        <NotificationContextProvider>
          <RouterProvider router={router} />
          <Analytics />
        </NotificationContextProvider>
      )}
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
